import { Component, inject, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageService } from '@aurrica-web/shared-i18n';
import { ThemeService }   from '@aurrica-web/core-data';
import { languages } from '../language/language';
import { LANDING_FREIGHT_LOGIN_URL } from '../landing-app-links';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: 'navBar.html',
  styles: [`
    .nav-link {
      position: relative;
      padding-bottom: 2px;
      color: var(--nav-text);
      transition: color 0.2s;
    }
    .nav-link::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 0;
      height: 1px;
      background: linear-gradient(to right, #008CF0, #00D4FF);
      transition: width 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .nav-link:hover { color: var(--nav-text-hover); }
    .nav-link:hover::after { width: 100%; }

    .mobile-nav-link {
      display: block;
      padding: 0.75rem 0.5rem;
      font-size: 1rem;
      font-weight: 600;
      color: var(--nav-mobile-link);
      border-bottom: 1px solid var(--theme-border);
      transition: color 0.2s;
    }
    .mobile-nav-link:hover { color: var(--nav-text-hover); }

    .theme-btn {
      width: 2.25rem;
      height: 2.25rem;
      border-radius: 50%;
      border: 1px solid var(--theme-border);
      background: var(--glass-bg);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background 0.25s, border-color 0.25s, transform 0.2s;
      color: var(--theme-icon-color);
    }
    .theme-btn:hover {
      border-color: rgba(0,140,240,0.45);
      background: rgba(0,140,240,0.1);
      transform: rotate(20deg);
    }
  `],
})
export class NavbarComponent implements OnInit {
  private languageService = inject(LanguageService);
  themeService            = inject(ThemeService);
  protected readonly freightLoginUrl = LANDING_FREIGHT_LOGIN_URL;

  languages = languages;
  isScrolled = false;
  isMobileMenuOpen = false;
  isLanguageDropdownOpen = false;

  selectedLanguage =
    this.languages.find(l => l.code === (localStorage.getItem('lang') || 'en')) ??
    this.languages[0];

  ngOnInit(): void {
    this.isScrolled = window.scrollY > 20;
  }

  @HostListener('window:scroll')
  onScroll(): void {
    this.isScrolled = window.scrollY > 20;
    if (this.isMobileMenuOpen && window.scrollY > 80) this.isMobileMenuOpen = false;
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    if (this.isMobileMenuOpen) this.isLanguageDropdownOpen = false;
  }

  closeMobileMenu(): void { this.isMobileMenuOpen = false; }

  toggleLanguageDropdown(): void {
    this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
  }

  closeLanguageDropdown(): void { this.isLanguageDropdownOpen = false; }

  changeLanguage(lang: (typeof languages)[0]): void {
    this.selectedLanguage = lang;
    this.languageService.setLang(lang.code);
    this.isLanguageDropdownOpen = false;
  }
}
